<template>
    <div class="bo-cell-user username">
        <img v-if="value.image" :src="value.image" class="avatar" />
        <div v-else-if="value.name" class="initials avatar">
            {{ userInitial(value.name) }}
        </div>
        <span> {{ value.name }}</span>
    </div>
</template>

<script>
export default {
    props: ["id", "value"],

    methods: {
        userInitial(userName) {
            var nameArray = userName.split(" ");
            var firstChar = userName.charAt(0);
            if (1 >= nameArray.length) {
                return firstChar;
            }
            var firstCharLastName = nameArray[nameArray.length - 1].charAt(0);
            return firstChar + firstCharLastName;
        },
    },
};
</script>